const defaultDateTime = 'dd-mm-yyyy H:MM:ss';
const defaultDate = 'dd-mm-yyyy';
const filterDateTime = 'dd/mm/yyyy HH:MM';
const filterDateTimeUTC = 'UTC:dd/mm/yyyy HH:MM';
const defaultDateTimeUTC = 'UTC:dd-mm-yyyy H:MM:ss';

export const availableDateFormats = {
  defaultDate,
  defaultDateTime,
  defaultDateTimeUTC,
  filterDateTime,
  filterDateTimeUTC,
};
